import script from "./drawlayoutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./drawlayoutComponent.vue?vue&type=script&setup=true&lang=js"

import "./drawlayoutComponent.vue?vue&type=style&index=0&id=658ce14e&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658ce14e"]])

export default __exports__